import moment from 'moment';
import { TIME_RANGE } from '~services/constant/common';

export default function (timeAlias, format) {
  switch (timeAlias) {
    case TIME_RANGE.today:
      return {
        startTime: moment().startOf('day').format(format),
        endTime: moment().endOf('day').format(format),
      };
    case TIME_RANGE.yesterday:

      return {
        startTime: moment().subtract(1, 'day').startOf('day').format(format),
        endTime: moment().subtract(1, 'day').endOf('day').format(format),
      };
    case TIME_RANGE['this-week']:

      return {
        startTime: moment().day(1).startOf('day').format(format),
        endTime: moment().endOf('day').format(format),
      };
    case TIME_RANGE['last-week']:

      return {
        startTime: moment().day(-6).startOf('day').format(format),
        endTime: moment().day(0).endOf('day').format(format),
      };
    case TIME_RANGE['this-month']:

      return {
        startTime: moment().startOf('month').format(format),
        endTime: moment().endOf('day').format(format),
      };
    case TIME_RANGE['last-month']:
      return {
        startTime: moment().subtract(1, 'month').startOf('month').format(format),
        endTime: moment().subtract(1, 'month').endOf('month').format(format),
      };
    case TIME_RANGE['this-quarter']:
      return {
        startTime: moment().startOf('quarter').format(format),
        endTime: moment().endOf('day').format(format),
      };
    case TIME_RANGE['last-quarter']:
      return {
        startTime: moment().subtract(1, 'quarter').startOf('quarter').format(format),
        endTime: moment().subtract(1, 'quarter').endOf('quarter').format(format),
      };
    case TIME_RANGE['this-year']:
      return {
        startTime: moment().startOf('year').format(format),
        endTime: moment().endOf('day').format(format),
      };
    case TIME_RANGE['last-year']:
      return {
        startTime: moment().subtract(1, 'year').startOf('year').format(format),
        endTime: moment().subtract(1, 'year').endOf('year').format(format),
      };
    default:
      return {
        startTime: moment().startOf('day').format(format),
        endTime: moment().endOf('day').format(format),
      };
  }
}
